/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_PhoneInputs */

const cs_field_phone = /** @type {(inputs: Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const en_field_phone = /** @type {(inputs: Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Field_PhoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_phone = /** @type {((inputs?: Field_PhoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_PhoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_phone(inputs)
	return cs_field_phone(inputs)
});